<template>
  <div v-title="$route.meta.title">
    <div class="page-heading header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="申请人"
                        prop="applicant">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入申请人名称，仅显示活跃状态的管理员"
              v-model="search.applicant"
              :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1,2,3,5]}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="部门"
                        prop="department_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入部门名称"
              v-model="search.department_id"
              :query-request="fetchDepartments"
              :find-request="getDepartmentDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="付款类型"
                        prop="type">
            <el-select v-model="search.type" clearable
                       multiple
                       class="width-max">
              <el-option v-for="(label, key) in {...type, 4: '批量付款'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审批状态"
                        prop="approve_status">
            <el-select v-model="search.approve_status"
                       class="width-max"
                       multiple
                       clearable>
              <el-option v-for="item in searchApproveStatus"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款状态"
                        prop="payment_status">
            <el-select v-model="search.payment_status"
                       clearable
                       multiple
                       class="width-max">
              <el-option v-for="item in searchPaymentStatus"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="申请日期"
                        prop="created_at">
            <el-date-picker
                v-model="search.created_at"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="付款日期"
                        prop="paid_date">
            <el-date-picker
                v-model="search.paid_date"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                :default-time="['00:00:00', '23:59:59']"
                clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="应付金额">
            <el-col :span="11">
              <el-form-item prop='apply_amount_min'>
                <el-input v-model="search.apply_amount_min" placeholder="请输入应付金额起始值"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <p style="padding: 0; margin: 0; text-align: center">至</p>
            </el-col>
            <el-col :span="11">
              <el-form-item prop='apply_amount_max'>
                <el-input v-model="search.apply_amount_max" placeholder="请输入应付金额起始值"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="是否加急"
                        prop="is_urgent">
            <el-select v-model="search.is_urgent" clearable
                       class="width-max">
              <el-option v-for="(label, key) in {1: '是', 0: '否'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款ID"
                        prop="id">
            <el-input v-model="search.id" placeholder="请输入付款ID"></el-input>
          </el-form-item>

          <el-form-item label="冲销时间"
                        prop="write_off_at">
            <el-date-picker
              v-model="search.write_off_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              :default-time="['00:00:00', '23:59:59']"
              clearable>
            </el-date-picker>
          </el-form-item>

          <el-form-item label="冲销状态"
                        prop="write_off_status">
            <el-select v-model="search.write_off_status" clearable
                       multiple
                       class="width-max">
              <el-option v-for="(label, key) in writeOffStatus"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="付款公司"
                        prop="payment_company">
            <remote-select
              multiple
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="仅支持搜索启用中的付款公司,可输入名称进行搜索"
              v-model="search.payment_company"
              :query-request="(_)=>fetchOurCompanies(Object.assign(_, {is_disabled: 0}))"
              :find-request="getOurCompaniesDetail">
            </remote-select>
          </el-form-item>

        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <template v-if="this.$route.query.old_export">
        <el-button type="primary"
                    @click="onExportFinanceSearch"
                    size="small">按财务格式导出(前端导出)
        </el-button>
        <el-button type="primary"
                    @click="onExportDetailSearch"
                    size="small">导出付款明细(前端导出)
        </el-button>
        <el-button type="primary"
                   @click="onExportWriteOffSearch"
                   size="small">导出预付款冲销明细(前端导出)
        </el-button>
        <el-button type="primary"
                   @click="onExportWriteOffStatus"
                   size="small">导出预付款冲销状态明细(前端导出)
        </el-button>
        </template>

        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinancePaymentList()"
                   size="small">按财务格式导出
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinancePaymentDetail()"
                   size="small">导出付款明细
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinanceWriteOffDetail()"
                   size="small">导出预付款冲销明细
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="exportFinanceWriteOffStatus()"
                   size="small">导出预付款冲销状态明细
        </el-button>

        <el-button type="primary"
                   @click="showSummaryVisible"
                   size="small">按搜索结果汇总
        </el-button>
        <el-button type="primary"
                    icon="sj-icon-pdf"
                    @click="onDownLoadPDFS"
                    :disabled="!multipleSelection.length"
                    size="small">批量生成PDF
        </el-button>
      </div>
      <el-table ref="table"
                :data="table"
                stripe
                highlight-current-row
                border
                :cell-style="cellStyle"
                style="width: 100%"
                @selection-change="val => this.multipleSelection = val">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column label="ID" width="70">
          <template slot-scope="scope">
            <router-link :to="`/payment-approval/detail/${scope.row.id}`">
              <span size="mini">{{scope.row.id}}</span>
            </router-link>
          </template>
        </el-table-column>
        <template v-for="(attr, index) of fields">
          <el-table-column v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="120"
                         v-if="[1,5].includes(user.usertype * 1)">
          <template slot-scope="scope">
            <button-gutter>
                <router-link :to="`/payment-approval/detail/${scope.row.id}`">
                  <el-button size="mini" type="success">查看</el-button>
                </router-link>
              <el-button type="warning" @click="checkReviewPermission(scope.row)" v-if="showReviewWriteOffButton(scope.row)" size="mini">冲销-审批</el-button>
              <el-button type="warning" @click="checkReviewPermission(scope.row)" v-if="[7].includes(scope.row.status)" size="mini">付款</el-button>
              <el-button type="danger" @click="checkRejectPermission(scope.row)" v-if="[5, 6, 7].includes(scope.row.status)" size="mini">拒付</el-button>
              <el-button type="warning" @click="checkReviewPermission(scope.row)" v-if="[5, 6].includes(scope.row.status)" size="mini">财务审批</el-button>
              <el-button type="warning" @click="checkRefundPermission(scope.row)" v-if="[8, 10].includes(scope.row.status) && scope.row.paid_amount_total * 1 > 0 && scope.row.paid_amount_total !== scope.row.refund_amount_total && scope.row.type !== 5" size="mini">退款</el-button>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <payment-summary-dialog
      title="付款汇总"
      :visible="summaryVisible"
      :data="paymentSummary"
      @closeDialog="summaryVisible = false"></payment-summary-dialog>
  </div>
</template>

<script>
import { searchRules } from '../payment-approval.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import paymentApprovalMixins from '../payment-approval.mixins'
import paymentInfoExportMixins from '@views/payment-manager/payment-info-export.mixins'
import PaymentSummaryDialog from '@/views/payment-manager/components/PaymentSummaryDialog'

export default {
  components: {
    PaymentSummaryDialog,
  },
  mixins: [table, dateTimePicker, paymentApprovalMixins, paymentInfoExportMixins],
  data () {
    return {
      searchRules,
      search: {
        applicant: null,
        type: [],
        department_id: null,
        payment_company: [],
        approve_status: [],
        payment_status: [],
        created_at: [],
        paid_date: [],
        write_off_at: [],
        write_off_status: [],
        apply_amount_min: null,
        apply_amount_max: null,
        is_urgent: null,
        id: null,
        is_from_finance: true,
      },
      searchFieldType: {
        is_urgent: String,
        applicant: Number,
        department_id: Number,
      },
      multipleSelection: [],
      paymentCompanys: {},
      originFirstSubjects: {},
      originSecondSubjects: {},
      summaryVisible: false,
      paymentSummary: [],
    }
  },
  computed: Vuex.mapState({
    type: state => state.paymentManager.type,
    searchApproveStatus: state => state.paymentManager.searchApproveStatus,
    searchPaymentStatus: state => state.paymentManager.searchPaymentStatus,
    user: state => state.login.user,
    invoiceType: state => state.paymentManager.invoiceType,
    writeOffStatus: state => state.paymentManager.writeOffStatus,
  }),
  async created () {
    await this.getFinCenterConfigs()
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getPaymentManagerTable', params)
    },
    exportTableData (params) {
      return request.page('exportTableData', params)
    },
    exportDetailTableData (params) {
      return request.page('exportDetailTableData', params)
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupSubjects(data)
        this.setupPaymentCompany(data)
      })
    },
    setupSubjects (data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
    },
    setupPaymentCompany (data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    expandData (data) {
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    checkIsNum (num) {
      const reg = /^[0-9]+.?[0-9]*$/
      return reg.test(num)
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportPaymentApprovalData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },

    checkRejectPermission (row) {
      const params = {
        id: row.id,
        is_test_permission: 1
      }
      const uri = 'rejectedPayment'
      request.loading(uri, params).then(res => {
        this.$prompt('请填写拒付原因', '提示', {
          inputPattern: /\S+/,
          inputErrorMessage: '请输入拒付原因',
        }).then(({value}) => {
          const params = {
            id: row.id,
            reject_reason: value,
          }
          this.rejectPayment(uri, params)
        }).catch(() => {
          this.$message.info('已取消')
        })
      }).catch((_) => {
        this.$alert('当前用户暂无操作权限', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    rejectPayment (uri, params) {
      request.common(uri, params).then((data) => {
        this.$message({
          showClose: true,
          message: '拒付成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },

    checkReviewPermission (row) {
      const params = {
        id: row.id,
        is_test_permission: 1
      }
      let uri = ''
      if ([8, 10].includes(row.status)) {
        if (row.write_off_states.includes(6)) {
          uri = 'finAccountantPassPaymentWriteOffData'
        } else if (row.write_off_states.includes(7)) {
          uri = 'finManagerPassPaymentWriteOffData'
        }
      } else if ([7].includes(row.status)) {
        uri = 'paymentApplication'
      } else if ([6].includes(row.status)) {
        uri = 'managerReviewPaymentApplication'
      } if ([5].includes(row.status)) {
        uri = 'accountantReviewPaymentApplication'
      }
      request.loading(uri, params).then(res => {
        this.$router.push(`/payment-approval/review/${row.id}`)
      }).catch((_) => {
        this.$alert('当前用户暂无操作权限', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    checkRefundPermission (row) {
      const params = {
        id: row.id,
        is_test_permission: 1
      }
      // /payment-applications/22/finance/refund
      let uri = 'refundPayment'
      request.loading(uri, params).then(res => {
        this.$router.push(`/payment-approval/refund/${row.id}`)
      }).catch((_) => {
        this.$alert('当前用户暂无操作权限', '提示', {type: 'warning'}).then(() => {
        })
      })
    },
    showFinanceEditBtn (row) {
      // 取消财务修改功能
      return false
      // 爱绩效发放付款单(type=5)不显示财务修改按钮
      // return [8, 10].includes(row.status) && ![5].includes(row.type)
    },
    fetchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {query_all: true, ...name})
    },
    getDepartmentDetail (id) {
      return request.common('getFinCenterDepartmentDetail', id)
    },
    cellStyle (row) {
      // 加急，且处于 待审批,财务审批,待付款,待修改 状态的条目,标红处理
      if (row.row.is_urgent && [1, 2, 3, 4, 5, 6, 7, 11, 13, 14].includes(row.row.status * 1)) {
        return 'color:red;font-weight:bold;'
      }
    },
    fetchOurCompanies (params) {
      return request.common('getFinCenterOurCompaniesTable', params)
    },
    getOurCompaniesDetail (id) {
      return request.common('getFinCenterOurCompaniesDetail', id).then(data => {
        data.data.id = String(data.data.id)
        return data
      })
    },
    getRemovedEmptySearch () {
      return removeEmptyParams(_.cloneDeep(this.search))
    },
    exportFinancePaymentList () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有付款单数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出财务格式的付款数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinancePaymentListApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    exportFinancePaymentDetail () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportDetailTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有付款单数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出付款明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinancePaymentDetailApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    exportFinanceWriteOffDetail () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportWriteOffDetailTableData({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有预付款冲销明细数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出预付款冲销明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinanceWriteOffDetailApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    exportFinanceWriteOffStatus () {
      const searchParams = this.getRemovedEmptySearch()
      this.exportWriteOffStatusDataRequest({...searchParams, per_page: 1}).then((res) => {
        if (res.data.total === 0) {
          this.$alert('当前查询条件下没有预付款冲销状态明细数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出预付款冲销状态明细数据？', '提示', {type: 'warning'}).then(() => {
          request.common('exportFinanceWriteOffStatusApi', this.getRemovedEmptySearch()).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    showSummaryVisible () {
      const fields = ['pending', '5', '6', '7', 'paid', 'other', 'summary']
      request.page('exportExportSearchAggregateData', removeEmptyParams(this.search)).then(({data}) => {
        data = {
          ...this.defalutValue,
          ...data
        }
        this.paymentSummary = fields.map(field => {
          return data[field]
        })
        this.summaryVisible = true
      })
    },
    showReviewWriteOffButton (row) {
      return row.write_off_states.some(item => [6, 7].includes(item)) && row.type === 3 && [8, 10].includes(row.status) && [1, 2].includes(row.write_off_status)
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-approval/pages/PaymentApprovalTable.vue